import { WorkspaceContext } from "../contexts/workspace-context"
import { useContext } from "react"

export default function useWorkspaceContext() {
  const context = useContext(WorkspaceContext)

  if (!context) {
    throw new Error(
      "useWorkspaceContext must be used within a WorkspaceProvider"
    )
  }

  return context
}
